import { render } from "./PropertiesTab.vue?vue&type=template&id=860f66c0&scoped=true"
import script from "./PropertiesTab.vue?vue&type=script&lang=js"
export * from "./PropertiesTab.vue?vue&type=script&lang=js"

import "./PropertiesTab.vue?vue&type=style&index=0&id=860f66c0&lang=css"
import "./PropertiesTab.vue?vue&type=style&index=1&id=860f66c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-860f66c0"

export default script